import { deleteApi, getApi, postApi, putApi } from "./general.service";

export const getDecks = async (data) => {
  const params = new URLSearchParams();
  params.set("take", String(data?.take || 1000));
  if (data?.search?.trim()) params.set("search", data.search.trim());
  if (data?.page != null) params.set("page", String(data.page));
  const decks = getApi(`/admin/deck${params.toString() ? `?${params.toString()}` : ""}`, data);
  return decks;
};

export const getDeck = async (data) => {
  let path = `/admin/deck/${data._id}`;
  if(data.notChequedContext === true)
    path+='?notChequedContext='+data.notChequedContext;
  const decks = getApi(path, data);
  return decks;
};

export const getDeckStats = async (data) => {
  const params = new URLSearchParams();
  params.set('take', String(Math.min(Math.max(1, data?.take || 20), 100)));
  if (data?.search?.trim()) params.set('search', data.search.trim());
  if (data?.page != null) params.set('page', String(data.page));
  if (data?.nextPageHash) params.set('nextPageHash', data.nextPageHash);
  const query = params.toString();
  return getApi(`/stats/deck/${data._id}${query ? `?${query}` : ''}`, data);
};

export const createDeck = async (data) => {
  const decks = postApi("/admin/deck", data);
  return decks;
};

export const getDeckCSV = async (data) => {
  const decks = getApi(`/admin/deck/${data._id}/export/csv`, data);
  return decks;
};

export const updateDeck = async (data) => {
  const decks = putApi("/admin/deck", data);
  return decks;
};

export const deleteDeck = async (data) => {
  const decks = deleteApi(`/admin/deck?_id=${data._id}`, data);
  return decks;
};

export const updateDeckAvatar = async (data) => {
  // No pasar Content-Type: axios lo añade con boundary correcto para FormData
  return postApi("/admin/deck/avatar", data);
};

export const getDeckImages = async (data) => {
  return getApi(`/admin/deck/${data._id}/images`, data);
};
